import Header from "../../components/Header";
import Footer from "../Home/components/Footer";

export default function AboutUs() {
  return (
    <>
      <Header home={false} />
      <div className="px-8 pb-8">
        {/* Intro Section */}
        <div className="p-12 rounded-xl flex flex-col items-center w-full bg-[#f2f8fd]">
          <h2 className="text-center text-4xl font-semibold mb-4">About Us</h2>
          <p className="text-center text-gray-600 max-w-3xl">
            We are a motivated and skilled group of engineers, driven by a
            shared mission: to make students’ lives more certain, confident, and
            successful.
          </p>
        </div>

        {/* Story Section */}
        <section className="p-12 max-w-5xl mx-auto">
          <h2 className="text-center text-4xl font-semibold mb-4">
            Who We Really Are
          </h2>
          <p className="text-center text-gray-600 leading-relaxed max-w-4xl mx-auto">
            We are experienced software engineers dedicated to solving
            real-world problems and building products that create tangible
            impact in the lives of students. Our journey began with addressing
            everyday challenges, and now we are focused on delivering more
            refined, student-centered solutions that can transform their future
            in meaningful ways.
          </p>
          <p className="text-center text-gray-600 leading-relaxed max-w-4xl mx-auto mt-4">
            We are committed to building and delivering products that drive real
            change on the ground — not just ideas that look good on paper. Best
            of all, our solutions are designed for everyone, not just the
            privileged few.
          </p>
        </section>

        {/* Call To Action */}
        <section className="py-12 px-6 text-center bg-[#f2f8fd] rounded-xl mb-0">
          <h2 className="text-3xl md:text-4xl font-semibold mb-2">
            Want to Collaborate?
          </h2>
          <p className="max-w-2xl mx-auto mb-6 opacity-90">
            We are looking for engineers, content strategists, and marketers to
            join our team and help us shape the future of student success.
          </p>
          <a
            href="https://wa.me/919471664452?text=Hello%21%20I%E2%80%99d%20like%20to%20request%20a%20collaboration%20for%20the%20ZEO%20App.%20Looking%20forward%20to%20hearing%20from%20you."
            target="__blank"
          >
            <button className="btn rounded-full font-semibold shadow-md transition">
              Contact Us
            </button>
          </a>
        </section>
      </div>
      <Footer />
    </>
  );
}
